import { Component, ElementRef, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { OrderCollapseComponent } from '@b2b/components/order/order-item/components/order-collapse/order-collapse.component';
import { TranslateModule } from '@ngx-translate/core';
import { OrderResponse } from '@b2b/features/order/utilities/order.model';
import { getDarkBrandLogo } from '@shared/helpers/getBrandLogo';
import { CartProductComponent } from '@b2b/components/cart/cart-product/cart-product.component';

@Component({
  selector: 'order-item',
  imports: [CommonModule, RouterModule, OrderCollapseComponent, TranslateModule, CartProductComponent],
  templateUrl: './order-item.component.html',
  styleUrls: ['./order-item.component.scss'],
})
export class OrderItemComponent {
  @Input() order?: OrderResponse;
  @Input() type?: 'order' | 'invoice' | 'ticket';

  isActive = false;

  private hostElement = inject(ElementRef);

  get hostClasses(): string[] {
    const classList = Array.from((this.hostElement.nativeElement as HTMLElement).classList);

    return classList;
  }

  toggleAccordion() {
    this.isActive = !this.isActive;

    return;
  }

  getBrandLogo(brandName: string): string {
    return getDarkBrandLogo(brandName);
  }

  getDate(dateString?: string | null): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR');
  }
}
